import styled, { css } from 'styled-components'
import { desktopBreakpoint, tabletBreakpoint, wideScreenBreakpoint } from 'react-components'

export const Section = styled.section(
    () => css`
        background: #eff7ff;
        width: 100%;
        margin-top: 1.5rem;
        position: relative;
        overflow: hidden;

        &::before {
            content: '';
            position: absolute;
            top: -1rem;
            left: 0;
            width: 100%;
            height: 2rem;
            background: white;
        }

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            width: 100vw;
            margin-left: 50%;
            transform: translateX(-50%);
            position: relative;

            &::before {
                width: 100vw;
                margin-left: -50vw;
                left: 50%;
            }
        }
    `,
)

export const Container = styled.div`
    width: inherit;
    overflow: hidden;
    max-width: 83rem;
    margin: auto;
    padding: 2rem 1rem 3rem;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        padding: 2.5rem 1.5rem 3rem;
    }

    @media only screen and (min-width: ${wideScreenBreakpoint.min}px) {
        padding: 3rem 4rem 4rem;
    }
`

export const TitleContainer = styled.div(
    () => css`
        width: inherit;
        padding: 0.75rem 0 0.25rem;

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            padding: 0.75rem 0.5rem 0.25rem;
        }

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            padding: 0.75rem 0 0.25rem;
        }
    `,
)

export const StyledCarouselProvider = styled.div`
    width: 100%;
    li {
        list-style: none;
    }
`

export const StyledSlider = styled.div`
    padding: 0;
    overflow: hidden;
`

export const StyledSlide = styled.div(
    ({ theme }) => css`
        padding-right: ${theme.spacing.medium};

        > div:first-child {
            height: 100%;
        }
    `,
)

export const CardsContainer = styled.div(
    () => css`
        margin-top: 1rem;

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 1rem;
            grid-template-rows: repeat(auto-fit, minmax(373px, auto));
            margin-top: 1rem;
        }

        @media only screen and (min-width: ${wideScreenBreakpoint.min}px) {
            gap: 2.5rem;
        }
    `,
)

export const TipCard = styled.div(
    ({ theme }) => css`
        background: ${theme.colors.white};
        border-radius: 0.75rem;
        border: ${theme.typography.border.width.xxxThin} ${theme.typography.border.style.solid}
            ${theme.colors.tfwBlackOpacity10};
        overflow: hidden;
        display: flex;
        flex-direction: column;
        height: 100%;
        box-shadow: 0 0.125rem 0.5rem rgba(0, 0, 0, 0.08);
        transition: box-shadow 0.2s ease-in-out;
        cursor: pointer;
        position: relative;

        &:hover {
            box-shadow: 0 0.5rem 1.5rem rgba(0, 0, 0, 0.12);
        }
    `,
)

export const TipCardOverlayLink = styled.a`
    position: absolute;
    inset: 0;
    z-index: 1;
`

export const TipCardImage = styled.div(
    () => css`
        width: 100%;
        height: 12.5rem;
        position: relative;
        overflow: hidden;

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            height: 13.75rem;
        }

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            height: 15.5rem;
        }
    `,
)

export const TipCardContent = styled.div(
    () => css`
        padding: 1rem 1.5rem;
        display: flex;
        flex-direction: column;
        gap: 0.25rem;
        flex: 1;
        position: relative;
        z-index: 2;

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            justify-content: space-between;
        }
    `,
)

export const TipCardTitle = styled.h3(
    ({ theme }) => css`
        margin: 0;
        font-family: ${theme.typography.font.family.latoVerdana};
        font-weight: 600;
        font-size: 1.25rem;
        line-height: 1.75rem;
        color: #282828;
    `,
)

export const TipCardDescription = styled.div(
    ({ theme }) => css`
        font-family: ${theme.typography.font.family.lato};
        font-weight: ${theme.typography.font.weight.normal};
        font-size: 0.9375rem;
        line-height: 1.5;
        color: #5f5f5f;
        flex: 1;

        p {
            margin: 0 0 ${theme.spacing.small};

            &:last-child {
                margin-bottom: 0;
            }
        }

        strong {
            font-weight: ${theme.typography.font.weight.bold};
        }

        a {
            color: #016bd4;
            text-decoration: underline;
            transition: color 0.2s ease-in-out;

            &:hover {
                color: #0159b8;
                text-decoration: underline;
            }

            &:visited {
                color: #016bd4;
            }

            &:active {
                color: #0159b8;
            }

            &:focus {
                outline: 0.125rem solid #016bd4;
                outline-offset: 0.125rem;
            }
        }

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            overflow: auto;
        }
    `,
)

export const ButtonContainer = styled.div`
    padding: 0.5rem 0;
`

export const TipCardButton = styled.span(
    ({ theme }) => css`
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 0.5rem 1.5rem;
        background-color: ${theme.colors.white};
        border: 1px solid #282828;
        border-radius: 0.75rem;
        font-family: ${theme.typography.font.family.latoVerdana};
        font-weight: 600;
        font-size: 0.875rem;
        line-height: 1.5rem;
        color: #282828;
        text-align: center;
        white-space: nowrap;
        width: 100%;

        @media only screen and (min-width: ${wideScreenBreakpoint.min}px) {
            width: 11.375rem;
        }

        &:active {
            background-color: ${theme.colors.white} !important;
            color: ${theme.colors.tfwBlack87};
            border-color: ${theme.colors.tfwBlack87};
        }

        &:focus {
            outline: none;
            background-color: ${theme.colors.white};
            color: ${theme.colors.tfwBlack87};
        }

        &:hover:not(:focus) {
            background-color: ${theme.colors.tfwYellowHover};
            color: ${theme.colors.tfwBlack87};
            border-color: ${theme.colors.tfwYellowHover};
        }

        @media (hover: none) and (pointer: coarse) {
            &:hover {
                background-color: ${theme.colors.white};
                color: ${theme.colors.tfwBlack87};
                border-color: ${theme.colors.tfwBlack87};
            }
        }
    `,
)
